import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MenuBar } from '../model/menu-bar.model';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class MenuBarHttpService {

  constructor(
    private http: HttpClient,
  ) { }

  getMenuBar(): Observable<MenuBar[]> {
    return this.http.get<ApiResponse>(`/menubar`).pipe(
      map(res => res.data.rows)
    );
  }

}